import React from 'react';
import { useSelector } from 'react-redux';
import { PopdownButton } from '../PopdownMenu';
import {
  DirectDestroyButton,
  EditButton,
  IncompleteEditButton,
  IncompleteDestroyButton,
} from '../../containers/clientAdminTiles/components/Buttons';

import { useShowTileForm } from '../../lib/redux/hooks/useShowTileForm';
import useHandleTiles from '../../lib/redux/hooks/useHandleTiles';
import { AcceptButton, IgnoreButton, UndoIgnoreButton } from './Buttons';

const PlanTileButtons = ({
  id,
  ignored,
  status,
  planDate,
  editPath,
  fullyAssembled,
}) => {
  const { editTile: oldEditTile, deleteTile } = useHandleTiles();
  const { editTile } = useShowTileForm();
  const { newTileForm } = useSelector(state => state.userData);

  const activeStatus = useSelector(state => state.status.activeStatus);

  return fullyAssembled ? (
    <>
      <PopdownButton tileId={id} />
      <div>
        <EditButton
          tileId={id}
          activeStatus={activeStatus}
          onClickAction={e => {
            e.preventDefault();
            if (newTileForm) {
              editTile({ tileId: id });
            } else {
              oldEditTile({ id, ignored, status, planDate, editPath });
            }
          }}
        />
      </div>
    </>
  ) : (
    <>
      <IncompleteEditButton
        tileId={id}
        activeStatus={activeStatus}
        onClickAction={e => {
          e.preventDefault();
          if (newTileForm) {
            editTile({ tileId: id });
          } else {
            oldEditTile({ id, ignored, status, planDate, editPath });
          }
        }}
      />
      <IncompleteDestroyButton
        tileId={id}
        onClickAction={e => {
          e.preventDefault();
          deleteTile({ ignored, status, id });
        }}
      />
    </>
  );
};

const SuggestTileButtons = ({ ignored, status, id }) => {
  const {
    undoIgnoreTile,
    deleteTile,
    ignoreTile,
    acceptTile,
  } = useHandleTiles();

  return ignored ? (
    <>
      <UndoIgnoreButton
        onClickAction={e => {
          e.preventDefault();
          undoIgnoreTile({ ignored, status, id });
        }}
      />
      <DirectDestroyButton
        tileId={id}
        onClickAction={e => {
          e.preventDefault();
          deleteTile({ ignored, status, id });
        }}
      />
    </>
  ) : (
    <>
      <IgnoreButton
        onClickAction={e => {
          e.preventDefault();
          ignoreTile({ id });
        }}
      />
      ,
      <AcceptButton
        onClickAction={e => {
          e.preventDefault();
          acceptTile({ ignored, status, id });
        }}
      />
      ,
    </>
  );
};

const buttonsPerStatus = {
  plan: PlanTileButtons,
  user_submitted: SuggestTileButtons,
};

const ShadowOverlayButtons = ({
  id,
  ignored,
  status,
  planDate,
  editPath,
  currentTab,
  fullyAssembled,
}) => {
  const Button = buttonsPerStatus[currentTab];

  return (
    <Button
      id={id}
      ignored={ignored}
      status={status}
      planDate={planDate}
      editPath={editPath}
      fullyAssembled={fullyAssembled}
    />
  );
};

export default ShadowOverlayButtons;
